import { render, staticRenderFns } from "./OwnerShareInput.vue?vue&type=template&id=7be7f6f6&scoped=true"
import script from "./OwnerShareInput.vue?vue&type=script&lang=js"
export * from "./OwnerShareInput.vue?vue&type=script&lang=js"
import style0 from "./OwnerShareInput.vue?vue&type=style&index=0&id=7be7f6f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be7f6f6",
  null
  
)

export default component.exports